import { Container, Row, Col } from 'react-bootstrap';

const Footer = () => (
  <footer className="footer">
    <Container fluid>
      <Row className="text-muted">
        <Col xs="6" className="text-start">
          <ul className="list-inline">
            <li className="list-inline-item">
              <a className="text-muted" href="https://smxemail.com/help-support/">
                Support
              </a>
            </li>
            <li className="list-inline-item">
              <a className="text-muted" href="https://smxemail.com/privacy-policy/ ">
                Privacy
              </a>
            </li>
            <li className="list-inline-item">
              <a className="text-muted" href="https://smxemail.com/terms-and-conditions/">
                Terms of Service
              </a>
            </li>
          </ul>
        </Col>
        <Col xs="6" className="text-end">
          <p className="mb-0">
            &copy; {new Date().getFullYear()} -{' '}
            <a href="https://smxemail.com" className="text-muted">
              SMX Limited
            </a>
          </p>
        </Col>
      </Row>
    </Container>
  </footer>
);

export default Footer;
